module.exports = __webpack_public_path__ + "static/carscallen-logo-66825c96bc32959d17b23ccb4c35be15.jpeg";